export default __webpack_public_path__ + "static/media/229.30e32c04.svg";